import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';

import 'styles';

const browser = typeof window !== 'undefined' && window;

const NotFoundPage = ({ path }) => {
  return (
    browser && (
      <Layout lightTheme path={path}>
        <Meta
          title="Error - Something went wrong"
          description="This page does not exist. Retry your URL."
        />
        <section className="section-404">
          <div className="container">
            <div className="row">
              <div className="col-md-5 offset-md-1">
                <h1 className="small-heading black-txt">
                  Oops! The page you were looking for doesn’t exist.
                </h1>
                <p>
                  You may have misstyped the address or the page may have moved.
                </p>
                <Link to="/" className="pink-btn">
                  <span>Go to homepage</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  );
};

NotFoundPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default NotFoundPage;
